<ng-container *ngIf="message.sentBy == 'user'">
  <!-- if not imag data -->

  <div
    class="message-container px-3 col-12 row d-flex justify-content-center align-items-center"
    style="margin-top: 0.5rem;"
    *ngIf="message.content !== 'false'"
  >
    <div
      class="position-relative justify-content-start flex-row-reverse align-items-top d-flex w-100"
    >
      <div class="UserMessage px-5 mx-2 position-relative" dir="auto">
        <span *ngIf="message.content.indexOf('attachment:') === -1" >
          {{ message.content }}
        </span>
        <span *ngIf="message.imageData">
          <a *ngIf="isImage()" (click)="openImageInNewWindow(message.imageData)">
            <img class="background-image" [src]="message.imageData" />
          </a>
          <video *ngIf="isVideo()" controls>
            <source class="media-content" [src]="message.imageData" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <button *ngIf="isAudio()" class="attachment-button" (click)="openAudioInNewWindow(message.imageData)">{{fileName}}</button>
          <button *ngIf="isPdf()" class="attachment-button" (click)="openPdfInNewWindow(message.imageData)">{{fileName}}</button>
        </span>
      </div>
      <span class="text-sm time">
        {{ message.timestamp | date: "HH:mm" }}
      </span>
    </div>
<!--     <div class="typing-indicator" style="margin-top: 10px;margin-left: 56px; "-->
<!--         *ngIf="lastMsg.timestamp < message.timestamp && message.content != 'Thanks for rating our service, Goodbye' && !isAgentConnected()">-->
<!--      <span></span>-->
<!--      <span></span>-->
<!--      <span></span>-->
<!--    </div> -->
  </div>

</ng-container>
<!-- End -->

<!-- Message Sent by Bot -->
<ng-container *ngIf="message.sentBy == 'bot'">

  <div
    *ngIf="message.content != 'table' && message.content != 'image'"
    class="position-relative px-3 d-flex align-items-top justify-content-start w-100"
    style="margin-top: 1rem;"
  >
    <div class="message-pic" style="margin-right: 5px;margin-top: 10px !important" >
      <img *ngIf="message.showImage"
              height="100%"
              src="assets/imgs/ot_icon_noor_36x36.svg"
      />
    </div>
    <!-- bot mssgs -->
    <div class="d-block">
      <div
        class="chatbotMessage" dir="auto"
        [ngStyle]="{ 'overflow-wrap':message.content.includes('http') ? 'anywhere' : 'break-word' }"
        *ngIf="message.content?.length>0 && message.imageDescription"
      >
        <span *ngIf= "readMoreButton && message.content.length > 200" [innerHTML]="message.content.slice(0,200).concat('...')"></span>
        <a (click)="readMoreButton = false" style="font-size: 12px;color:#182F7C" href="javascript:;" *ngIf="readMoreButton && message.content.length > 200">See more</a>
        <span *ngIf="!readMoreButton || message.content.length <= 200" [innerHTML]="message.imageDescription" class="message-content"></span>
      </div>

      <div *ngIf="message.imageList?.length > 0" style="display: flex; flex-direction: column; gap: 1rem; margin-bottom: 1rem;">
        <div *ngFor="let item of message.imageList" style="width: 100%;">
        
          <a *ngIf="getFileType(item.url) === 'image'" (click)="openImageInNewWindow(item.url)">
            <img
              [src]="item.url"
              [alt]="item.alt || 'Attachment'"
              style="width: 100%; height: auto; border-radius: 4px;"
            />
          </a>
        
          <video
            *ngIf="getFileType(item.url) === 'video'"
            controls
            style="width: 100%; border-radius: 4px;"
          >
            <source [src]="item.url" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        
           <button *ngIf="isAudio()" class="attachment-button" (click)="openAudioInNewWindow(item.url)">
              {{ item.alt }}
            </button>
          
          <button
            *ngIf="['pdf', 'pptx'].includes(getFileType(item.url))"
            class="attachment-button"
            style="width: 100%; text-align: left; margin-top: 10px;"
            (click)="openFile(item.url)"
          >
            {{ item.alt || 'Open ' + getFileType(item.url).toUpperCase() }}
          </button>
        
          <div *ngIf="getFileType(item.url) === 'other'" class="text-muted">
            Unsupported file type
          </div>
        
        </div>
      </div>

      <!-- Carousel display -->
      <ngb-carousel 
          *ngIf="message?.carouselData?.length"
          [showNavigationArrows]="true" 
          [showNavigationIndicators]="false" 
          [interval]="0"
          class="custom-carousel">

        <ng-template ngbSlide *ngFor="let card of message.carouselData">
          <div class="carousel-card position-relative">
            <img [src]="card.carouselImageUrl" class="w-100 rounded" alt="Carousel image" />
            <div class="mt-4">
              <div style="display: flex; justify-content: center; align-items: center;">
                <b style="font-weight: 700;">{{ card.title }}</b>
              </div>
              <p>{{ card.longMessage }} </p>
            </div>
            <div class="mt-3 mb-3 button-group" *ngIf="card.buttons?.length">
              <button
                *ngFor="let btn of card.buttons; let i = index"
                class="attachment-button carousel-button mr-2"
                (click)="sendMessage1(
                  btn.text,
                  'btn-' + message.timestamp + '-' + i,
                  'offersyou',
                  'btn' + message.timestamp + '-' + i,
                  card.offerId,
                  { title: btn.text, value: btn.value }
                )"
              >
                {{ btn.text }}
              </button>
            </div>
          </div>
        </ng-template>
      </ngb-carousel>

      <!-- Suggestions cards -->
      <div class="d-inline-block" *ngIf="message.buttons?.length" dir="auto">
        <div
          id="{{ 'btn-' + message.timestamp }}"
          *ngIf="message.buttons.length > 0"
          class="suggestions-wrapper"
        >
          <button
                  style="margin-right: 10px; max-width: 260px; white-space: inherit;"
            name="{{ 'btn' + message.timestamp }}"
                  id="{{ 'btn' + message.timestamp+i }}"
            class="btn-outline-primary my-1"
            [ngStyle]="{'line-height': resButton.text.length > 32 ? '20px' : '36px'}"
            *ngFor="
              let resButton of message.buttons;let i =index
            "
            mat-button
            (click)="
              sendMessage1(
                resButton.text,
                'btn-' + message.timestamp,
                message?.slotToElicit,
                'btn' + message.timestamp+i,
                'text'+i,
                { title: resButton.text, value: resButton.value }
              )
            "
          >
            <ng-container *ngIf="resButton">
              <span id="text{{i}}">{{ resButton.text }}</span>
            </ng-container>
          </button>
        </div>
      </div>


    </div>

    <span class="text-sm time px-2 chatbot-time" *ngIf="message.content && message.showImage">
      <span *ngIf="message.content.length > 2">
        {{ message.timestamp | date: "HH:mm" }}
      </span>
    </span>
  </div>


  <app-tabledata *ngIf="message.content == 'table'" [table] = "message.table"></app-tabledata>
  <app-card-slider-button *ngIf="message.content == 'image'" [imageDescription] = "message.imageDescription" (sendMessageEV)="sendMessage($event, '100' ,message?.slotToElicit)"></app-card-slider-button>
  <iframe width="300" height="315" *ngIf="showYoutubeVideo" class="video" [src]="youtubeVideoPath" allowfullscreen></iframe>
</ng-container>
<!-- End -->
